export const getIconForCollection = (name: string) => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('vegetable') || lowerName.includes('veggies') || lowerName.includes('salad')) return 'las la-carrot';
    if (lowerName.includes('beverage') || lowerName.includes('drink') || lowerName.includes('coffee')) return 'las la-coffee';
    if (lowerName.includes('pulse') || lowerName.includes('dal') || lowerName.includes('wheat') || lowerName.includes('rice') || lowerName.includes('grain')) return 'las la-wheat';
    if (lowerName.includes('fruit')) return 'las la-apple-alt';
    if (lowerName.includes('dairy') || lowerName.includes('milk')) return 'las la-glass-whiskey';
    if (lowerName.includes('meat') || lowerName.includes('chicken') || lowerName.includes('beef')) return 'las la-drumstick-bite';
    if (lowerName.includes('fish') || lowerName.includes('seafood')) return 'las la-fish';
    if (lowerName.includes('egg')) return 'las la-egg';
    if (lowerName.includes('baby')) return 'las la-baby';
    if (lowerName.includes('snack')) return 'las la-cookie-bite';
    if (lowerName.includes('alcohol') || lowerName.includes('beer') || lowerName.includes('wine')) return 'las la-beer';
    if (lowerName.includes('packaging')) return 'las la-box';
    if (lowerName.includes('cleaning') || lowerName.includes('hygiene')) return 'las la-broom';
    if (lowerName.includes('equipment') || lowerName.includes('appliance')) return 'las la-blender';
    if (lowerName.includes('service')) return 'las la-concierge-bell';
    if (lowerName.includes('rental')) return 'las la-truck';
    return 'las la-shopping-basket';
};
